import { useCallback } from 'react'

import PlainSelector from 'app/common/ui-next/plain-selector'
import PlainButtonAsLink from 'app/common/ui-next/plain-button-as-link'
import { dispatchFormChanged } from 'app/common/ui-next/custom-events'

import { SchoolSelectionModal } from './SchoolSelectionModal'
import type { SurveyFilterItemProps } from './types'

export const SchoolFilter = ({
  value,
  options,
  loading,
  colorInverse,
  disabled,
  onChange,
}: SurveyFilterItemProps) => {
  const makeTitle = useCallback(
    (id: string) => options.schools.find((school) => school.id === id)?.title || 'Неизвестный элемент',
    [options.schools],
  )
  const handleChange = (schoolIds: Array<string>) => {
    onChange({ ...value, schoolIds })
    dispatchFormChanged()
  }
  const selectionDisabled = loading || !value.cityIds.length || disabled

  return (
    <PlainSelector
      id="surveySchool"
      label="Заведение"
      selection={value.schoolIds}
      makeTitle={makeTitle}
      makeSortable={makeTitle}
      multiple
      colorInverse={colorInverse}
      disabled={selectionDisabled}
      onChange={handleChange}
      selectedAllOnEmptySelection
      skipUpperSpace
      maxViewCountBadge={3}
    >
      {(selection, update) => (
        <SchoolSelectionModal
          schools={options.schools}
          districts={options.districts}
          selection={selection}
          onChange={update}
        >
          {(toggle) => (
            <PlainButtonAsLink onClick={toggle} disabled={selectionDisabled}>
              {'Выбрать'}
            </PlainButtonAsLink>
          )}
        </SchoolSelectionModal>
      )}
    </PlainSelector>
  )
}
